import { render, staticRenderFns } from "./ReportImageList.vue?vue&type=template&id=0afd42c5&scoped=true"
import script from "./ReportImageList.vue?vue&type=script&lang=js"
export * from "./ReportImageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd42c5",
  null
  
)

export default component.exports